<template>
	<div class="order-items-editor">
    <input type="hidden" name="details" v-model="detailsImploded">

		<div class="title">
			<span class="text-grey">
				Order items:
			</span>
		</div>
		<div class="items-autocomplete">
      <select name="selectedMenuItem"
              class="form-control select2-input"
              v-model="selectedItemId"
              id="selectedMenuItem">
        <option value="">Select item to add</option>
        <option v-for="(item, itemId) in allAvailableItems" :value="itemId" :key="itemId">
          [{{item.category_name}}] {{item.title}}, {{itemId}}, ${{item.price}}
        </option>
      </select>

      <button class="button button-primary-outline text-nowrap add-item mt-2" type="button" @click="addItem">
        <i class="fas fa-circle-plus"></i>
        Add item
      </button>
		</div>

		<table class="order-items table">
			<tbody>
				<tr v-for="(item, itemId) in details.items" :key="itemId">
					<td>
						<img :src="item.thumbnail"
                 style="max-width: 80px"
                 alt=""
            />
					</td>
					<td class="order-item-title">
						{{item.title}} {{item.ProductCode}}

            <div class="font-italic font-weight-normal">
							{{item.comment}}
						</div>
					</td>
					<td>
						<input type="number"
					           style="width: 55px;padding: 5px 8px;"
					           class="form-control grey-input white"
					           min="1"
					           step="1"
					           @change="updateTotalPrice"
					           v-model="item.qty"
						/>
					</td>
					<td class="price">
						${{item.qty * item.price}}
					</td>
					<td class="actions">
						<button class="button action remove" @click="removeItem(itemId)" type="button">
							&times;
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		name: "OrderItemsEditor",
    data(){
      return {
        selectedItemId: '',
        detailsImploded: '',
        allAvailableItems: {},
        details: {},
      }
    },
    mounted() {
			this.details = JSON.parse($("#order-details").text());
			this.detailsImploded = JSON.stringify(this.details);
			$("#order-items").remove();

			this.allAvailableItems = JSON.parse($("#all-items").text());
			$("#all-items").remove();

			setTimeout(() => {
				$("#selectedMenuItem").select2({
					width: '100%',
					allowClear: true
				})
			},100);
		},
		methods: {
			addItem() {
				let selectedItemId = $("#selectedMenuItem").val();

				if(!selectedItemId) {
					return;
				}

				this.details.items = this.details.items ? this.details.items : {};

				let item = this.allAvailableItems[selectedItemId];

				let existingItem = this.details.items[selectedItemId];

				if(existingItem){
					this.details.items[item.id].qty += 1
				} else {
					this.details.items[item.id] = item;
					this.details.items[item.id].qty = 1
				}
				this.selectedItemId = '';
				this.updateTotalPrice();
				this.$forceUpdate();
			},
			removeItem(itemId){
				$.confirm({
					title: '',
					content: `<div style="font-size: 1.3em">Are you sure want to remove this item from order?</div>`,
					buttons: {
						confirm: {
							text: 'Ok',
							btnClass: 'btn btn-success',
							keys: ['enter'],
							action: () => {
								delete this.items[itemId];
								this.updateTotalPrice()
							}
						},
						cancel: {
							text: 'Cancel',
							btnClass: 'btn btn-danger',
							keys: ['esc', 'escape'],
						},
					}
				})


			},
			updateTotalPrice(){
				let totalPrice = 0;
				for(let itemId in this.details.items){
					totalPrice += this.details.items[itemId].price * this.details.items[itemId].qty
				}

				$("#price").val(totalPrice.toFixed(2).replace(',', '.'))
        this.detailsImploded = JSON.stringify(this.details)
			}
		}
	}
</script>

<style scoped>

</style>
